import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=0d7c2f80"
import script from "./TermsAndConditions.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditions.vue?vue&type=script&lang=ts"
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=0d7c2f80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports